import { render, staticRenderFns } from "./CodeHighlight.vue?vue&type=template&id=88898ba0&scoped=true"
import script from "./CodeHighlight.vue?vue&type=script&lang=js"
export * from "./CodeHighlight.vue?vue&type=script&lang=js"
import style0 from "./CodeHighlight.vue?vue&type=style&index=0&id=88898ba0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88898ba0",
  null
  
)

export default component.exports